<template>
  <div class="r-topic-buttons">
    <div class="icons">
      <Button key="visit" icon="md-eye" size="small" v-if="visit >= 0" type="text">
        <span>{{ visit }}</span>
      </Button>
      <!-- @click="resetReply" -->
      <Button key="comment" size="small" v-if="comment >= 0" type="text">
        <div class="button">
          <img class="comment_img" src="../../assets/icons/topic_comment.png" alt="">
          <span>{{ Number(comment) > 10000 ? (Number(comment)/10000).toFixed(1) + 'w': Number(comment) }}</span>
        </div>
      </Button>
      <!-- 点赞 -->
      <!--  -->
      <Button key="like" size="small" v-if="like >= 0" type="text" :class="{'active': likeState}" @click="handleLike">
        <div class="button">
          <img class="like_img" src="../../assets/icons/topic_like.png" alt="">
          <span>{{ Number(likeCount) > 10000 ? (Number(likeCount) / 10000).toFixed(1) + 'w' : Number(likeCount) }}</span>
        </div>
      </Button>
    </div>

    <div>
      <!-- 修改按钮 -->
      <Button key="edit" icon="md-create" size="small" v-if="showEdit" @click="doEdit" shape="circle" />
      <!-- 删除按钮 -->
      <Button key="default" icon="md-trash" size="small" v-if="showDel" @click="doDel" shape="circle" />
      <Button key="share" icon="md-share-alt" size="small" v-if="showShare" @click="doShare" shape="circle">
        <span>分享</span>
      </Button>

      <Button key="favorite" shape="circle" size="small" :loading="submitting > 0"
        :icon="favoriteState ? 'md-heart' : 'md-heart-outline'" @click="handleFavorite" v-if="showFavorite"
        :type="favoriteState ? 'primary' : null">
        <span>{{ favoriteState ? '已收藏' : '收藏' }}</span>
      </Button>
      <Button disabled size="small" type="text" v-show="date" icon="md-calendar">{{ date }}</Button>
    </div>
  </div>
</template>

<script type="text/javascript">
  import TopicMix from './TopicMix'
  export default {
    name: 'topic-buttons',
    mixins: [TopicMix],
    data() {
      return {
        favoriteState: null,
        likeState: null,
        submitting: 0,
        likeCount: 0
      }
    },
    props: {
      visit: [String, Number],
      comment: [String, Number],
      like: [String, Number],
      // 编辑按钮
      edit: Boolean,
      // 删除按钮
      del: Boolean,
      // 分享
      share: Boolean,
      // 收藏按钮
      isFavorite: null,
      isLike: null,
      secondId: null,
      // 日期
      date: String,
    },
    methods: {
      resetReply() {
        this.$emit('resetReply')
      },
      handleFavorite() {
        if (this.isLogin) {
          const api = this.favoriteState ? 'un-collect' : 'collect'
          this.submitting++
          this.$Ajax(api, {
            collectId: this.topicId
          }).then(({
            status
          }) => {
            if (status == 1) {
              this.favoriteState = !this.favoriteState
            }
          }).finally(() => {
            this.submitting--
          })
        } else {
          this.$mypopup({
            onSuccess: () => {
              const api = this.favoriteState ? 'un-collect' : 'collect'
              this.submitting++
              this.$Ajax(api, {
                collectId: this.topicId
              }).then(({
                status
              }) => {
                if (status == 1) {
                  this.favoriteState = !this.favoriteState
                }
              }).finally(() => {
                this.submitting--
              })
            }
          })
        }
      },
      handleLike() {
        const api = this.likeState ? 'com/un-like-topic' : 'com/like-topic'
        this.$Ajax(api, {
          topic_id: this.topicId
        }).then(rs => {
          if (rs.code == 200) {
            if (this.likeState) {
              if (this.likeCount > 0) this.likeCount--
            } else {
              this.likeCount++
            }
            this.likeState = !this.likeState
          }
        })
      }
    },
    computed: {
      showShare() {
        return this.share && this.row.status == 1
      },
      showEdit() {

        return this.edit && this.isSelf && this.row.rough == 1
      },
      showDel() {
        return this.del && this.isSelf && this.row.status == 0
      },
      showFavorite() {
        return typeof this.isFavorite == 'boolean' && this.row.status == 1
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
    },
    watch: {
      isFavorite: {
        immediate: true,
        handler(b) {
          this.favoriteState = b
        }
      },
      isLike: {
        immediate: true,
        handler(b) {
          this.likeState = b
        }
      },
      like: {
        immediate: true,
        handler(v) {
          this.likeCount = Number(v) || 0
        }
      }
    }
  }
</script>
<style lang="less" scoepd>
  .r-topic-buttons {
    .ivu-btn {
      padding: 0;
      margin-left: .9rem;

      &:hover,
      &:active,
      &:focus,
      &.active {
        background-color: transparent;
        border-color: transparent;
        color: #656565;
        box-shadow: unset;
      }
      .button {
        display: flex;
        align-items: center;
        color: #9e9e9e;

        .comment_img {
          width: .9rem;
          height: .75rem;
          margin-right: .1rem;
        }

        .like_img {
          width: .75rem;
          height: .7rem;
          margin-right: .1rem;
        }
      }
    }
  }
</style>